export default "__VITE_ASSET__DTFw8Nty__"